<template>
  <div class="privacy-wrapper">
    <div class="privacy-card-container">
      <div class="privacy-card" ref="privacyContent" @scroll="handleScroll()" style="height: calc(75vh - 100px)!important;overflow-y: auto;">
        <div class="privacy-info">
          <div class="info-row">
            <span class="label">{{ $t('labelIAM') }}</span>
            <span class="value">{{ user ? user.name : '' }}</span>
          </div>
          <div class="info-row">
            <span class="label">{{ $t('labelMyEmail') }}</span>
            <span class="value">{{ user ? user.email : '' }}</span>
          </div>
          <div class="info-row" v-html="$t('privacyAgreementNote', { date: currentDateStr })">
          </div>
        </div>

        <div class="privacy-highlight mt-2" v-if="privacyPolicy && privacyPolicy.summaryChanges">
          <div class="highlight-header">
            <b-icon icon="info-circle-fill" class="mr-2"></b-icon>
            <span class="highlight-title">{{ $t('privacyChangeContent') }}</span>
          </div>
          <div class="highlight-body">
            <div v-html="privacyPolicy.summaryChanges"></div>
          </div>
        </div>

        <div class="privacy-version mt-3">
          {{ $t('versionInfo', { version: privacyPolicy ? privacyPolicy.versionTag : '', date: privacyPolicy ? formatDate(privacyPolicy.effectiveDate) : '' }) }}
        </div>
        <!-- <div class="mt-2"><h5 style="text-transform: uppercase;">{{ privacyPolicy ? privacyPolicy.title : '' }}</h5></div> -->
        <div class="privacy-scroll mt-2">
          <div v-html="privacyContent"></div>
        </div>
      </div>

      <!-- Floating scroll guide overlay -->
      <transition name="fade">
        <div v-if="!isScrolledToBottom" 
             class="privacy-scroll-guide" 
             @mousedown="startScrolling"
             @mouseup="stopScrolling"
             @mouseleave="stopScrolling"
             @touchstart="startScrolling"
             @touchend="stopScrolling">
          <b-icon icon="chevron-double-down" class="guide-icon bounce-animation mr-2"></b-icon>
          <span class="guide-text">{{ $t('policyScrollToRead') }}</span>
        </div>
      </transition>
    </div>

    <div class="privacy-checkbox-section mt-2 d-flex align-items-start">
      <div :id="'privacy-checkbox-wrapper-' + modalId" class="checkbox-container">
        <b-form-checkbox class="custom-chk-only" v-model="isAgreed" :disabled="!isScrolledToBottom" @change="onAgreedChange">
        </b-form-checkbox>
      </div>
      <div class="checkbox-label-text" @click="!isScrolledToBottom ? null : toggleAgreement()">
        {{ $t('signUpIAgreeWith') }}
        <!-- <span class="policy-link">{{ privacyPolicy ? privacyPolicy.title : '' }}</span> <span v-html="$t('vnptGomeet')"></span> -->
         <a href="https://vnptai.io/vi/dieukhoansudung" target="_blank" class="terms-link">{{ $t("signUpTermOfUse") }}</a>,
                  <span target="_blank">{{ $t("personalDataProtectionPolicy") }}</span>
                  {{ $t("and") }}
                  <a href="https://vnptai.io/vi/chinhsachbaomat" target="_blank" class="terms-link">{{ $t("signUpPrivacyPolicy") }}</a>
                  {{ $t("productVnptGoMeet") }}

          <b-tooltip :target="'privacy-checkbox-wrapper-' + modalId" 
                 triggers="hover" 
                 :disabled="isScrolledToBottom" 
                 placement="top"
                 custom-class="privacy-tooltip">
          {{ $t('policyReadToConfirm') }}
        </b-tooltip>
      </div>
    </div>

    <!-- Error message display -->
    <transition name="fade">
      <div v-if="errorMessage" class="privacy-error-message mt-2 text-danger text-center animate-shake" style="font-size: 13.5px; font-weight: 500;">
        <b-icon icon="exclamation-circle" class="mr-1"></b-icon>
        <span>{{ errorMessage }}</span>
      </div>
    </transition>

    <div class="privacy-actions mt-3">
      <b-button block class="btn-accept" @click="onClickAcceptPrivacy">{{ $t('btnAcceptAndContinue') }}</b-button>
      <b-button block class="btn-reject" @click="onClickLogout">{{ $t('btnLogoutOrReject') }}</b-button>
    </div>
  </div>
</template>
<style scoped lang="scss">
.privacy-wrapper {
  font-family: 'Be Vietnam Pro', sans-serif;
  color: #2D3748;
}

.privacy-card {
  padding-right: 15px;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #E2E8F0;
    border-radius: 10px;
  }
}

.privacy-info {
  background: rgba(0, 150, 255, 0.03);
  padding: 20px;
  border-radius: 12px;
  border: 1px solid rgba(0, 150, 255, 0.1);
}

.info-row {
  display: flex;
  margin-bottom: 8px;
  font-size: 14px;
  .label {
    min-width: 120px;
    color: #718096;
    font-weight: 500;
  }
  .value {
    color: #1A202C;
    font-weight: 600;
  }
}

.privacy-highlight {
  background: rgba(0, 150, 255, 0.02);
  border-radius: 12px;
  padding: 16px 20px;
  border-left: 4px solid #0096FF;
  border: 1px solid rgba(0, 150, 255, 0.1);
  border-left-width: 4px;

  .highlight-header {
    display: flex;
    align-items: center;
    color: #004f9e;
    margin-bottom: 10px;
    
    .highlight-title {
      font-weight: 700;
      font-size: 15px;
      text-transform: uppercase;
      letter-spacing: 0.02em;
    }
  }

  .highlight-body {
    font-size: 14px;
    color: #4A5568;
    line-height: 1.6;
    padding-left: 26px;
  }
}

.privacy-version {
  font-size: 13px;
  color: #718096;
  font-style: italic;
}

.privacy-scroll {
  line-height: 1.7;
  font-size: 15px;

  ::v-deep .article-section {
    margin-bottom: 30px;
  }

  ::v-deep .article-title {
    font-size: 18px;
    color: #003169;
    font-weight: 700;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 2px solid rgba(0, 150, 255, 0.1);
    display: block;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 40px;
      height: 2px;
      background: #0096FF;
    }
  }

  ::v-deep p {
    margin-bottom: 1rem;
    text-align: justify;
  }

  ::v-deep ul, ::v-deep ol {
    padding-left: 1.5rem;
    margin-bottom: 1.5rem;
  }

  ::v-deep li {
    margin-bottom: 0.5rem;
  }

  ::v-deep .highlight-card {
    background: linear-gradient(135deg, #003169 0%, #004f9e 100%);
    color: #fff;
    padding: 20px;
    border-radius: 12px;
    margin: 20px 0;
    h4 {
      color: #fff;
      font-size: 16px;
      margin-bottom: 10px;
      border: none;
      padding: 0;
      &::after { display: none; }
    }
    p { margin-bottom: 0; font-size: 14px; }
  }

  ::v-deep .sub-section {
    background: #F7FAFC;
    border-left: 3px solid #E2E8F0;
    padding: 15px 20px;
    margin: 15px 0;
    border-radius: 0 8px 8px 0;
  }

  ::v-deep header, ::v-deep nav.navbar, ::v-deep .policy-hero, ::v-deep .footer-premium, ::v-deep .policy-container {
     all: unset !important;
     display: block !important; // Ensure it doesn't break if unset
  }
  
  // Since we are injecting the whole file, we might have tags that should be ignored in modal
  ::v-deep header, ::v-deep nav.navbar, ::v-deep .footer-premium {
    display: none !important;
  }
}

.policy-link {
  color: #004f9e;
  font-weight: 700;
  text-decoration: none;
}

.btn-accept {
  background: #004f9e !important;
  color: #ffffff !important;
  border: none !important;
  height: 48px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.25s ease;
  
  &:hover:not(:disabled) {
    background: #0062c4 !important;
    box-shadow: 0 4px 12px rgba(0, 120, 240, 0.25);
  }
  
  &:disabled {
    background: #e2e8f0 !important;
    color: #94a3b8 !important;
    cursor: not-allowed;
    opacity: 1 !important;
    box-shadow: none !important;
  }
}

.btn-reject {
  background: #f8fafc !important;
  color: #64748b !important;
  border: 1px solid #e2e8f0 !important;
  height: 48px;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.25s ease;
  
  &:hover {
    background: #f1f5f9 !important;
    color: #334155 !important;
    border-color: #cbd5e1 !important;
  }
}

.checkbox-container {
  display: inline-block;
  ::v-deep .custom-control {
    padding-left: 1.5rem;
    margin-right: 0;
  }
}

.checkbox-label-text {
  flex: 1;
  font-size: 14px;
  color: #4A5568;
  line-height: 1.4;
  cursor: pointer;
  user-select: none;
  margin-top: 2px;
}

.terms-link {
  color: #137ae1;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease, text-decoration 0.2s ease;
  text-decoration: underline;
  &:hover {
    color: #004f9e;
    text-decoration: underline;
  }
}

.privacy-card-container {
  position: relative;
}

.privacy-scroll-guide {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  background-color: rgba(0, 120, 240, 0.92);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(0, 120, 240, 0.45);
  border-radius: 30px;
  box-shadow: 0 8px 30px rgba(0, 120, 240, 0.35);
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  z-index: 100;
  transition: all 0.3s ease;
  user-select: none;
  
  &:hover {
    background-color: rgba(0, 100, 220, 1);
    box-shadow: 0 10px 35px rgba(0, 120, 240, 0.5);
    transform: translateX(-50%) translateY(-2px);
  }

  .guide-icon {
    font-size: 16px;
    color: #ffffff;
  }
}

/* Bouncing animation for chevron */
@keyframes bounce-down {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(4px);
  }
}

.bounce-animation {
  animation: bounce-down 1.6s infinite ease-in-out;
}

/* Fade transition */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(10px);
}

/* Shake animation for validation errors */
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-4px); }
  75% { transform: translateX(4px); }
}

.animate-shake {
  animation: shake 0.3s ease-in-out;
}
</style>
<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import BaseComponent from "@/components/BaseComponent";
import * as userService from "@/service/userService";
import * as policyService from "@/service/policyService";
import * as util from "@/service/util";
import { PrivacyPolicy } from "@/model/PrivacyPolicy";
import { PrivacyConsentSource } from '@/views/enums/PrivacyConsentSource';

@Component
export default class PrivacyModal extends BaseComponent {
  @Prop({ type: String, required: true }) readonly modalId!: string;
  @Prop({ type: Object, required: false, default: null }) readonly privacyPolicy!: PrivacyPolicy | null;
  privacyContent = "";
  isScrolledToBottom = false; // Trạng thái kiểm soát việc người dùng đã cuộn tới cuối trang điều khoản hay chưa
  isAgreed = false; // Trạng thái checkbox đồng ý điều khoản
  hasReachedBottom = false; // Cờ đánh dấu người dùng đã cuộn tới cuối trang ít nhất 1 lần để tránh khoá lại khi cuộn ngược lên
  errorMessage = ""; // Thông báo lỗi xác nhận điều khoản hiển thị trên giao diện
  private resizeObserver: ResizeObserver | null = null; // Theo dõi thay đổi kích thước DOM khi render dynamic HTML
  private scrollIntervalId: number | null = null; // ID của tiến trình cuộn tự động (requestAnimationFrame)

  get currentDateStr() {
    return util.localDateTimeFormat(new Date());
  }

  formatDate(value: any) {
    return util.localDateFormat(value);
  }

  mounted() {
    this.loadContent();
    this.setupResizeObserver();
  }

  beforeDestroy() {
    // Huỷ tiến trình cuộn tự động nếu đang chạy
    this.stopScrolling();
    // Huỷ đăng ký ResizeObserver để tránh rò rỉ bộ nhớ khi huỷ component
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  /**
   * Khởi tạo bộ quan sát kích thước của phần tử chứa nội dung điều khoản.
   * Giúp tự động tính toán lại trạng thái cuộn khi nội dung HTML (v-html) tải trễ
   * hoặc khi kích thước phần tử thay đổi (ví dụ: ảnh load xong, đổi kích thước cửa sổ).
   */
  setupResizeObserver() {
    const content = this.$refs.privacyContent as HTMLElement;
    if (!content) return;
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => {
        this.handleScroll();
      });
      this.resizeObserver.observe(content);
    }
  }

  async loadContent() {
    // Reset lại toàn bộ trạng thái cuộn khi bắt đầu load nội dung mới
    this.isScrolledToBottom = false;
    this.hasReachedBottom = false;
    if (this.privacyPolicy && this.privacyPolicy.fullContent) {
      this.privacyContent = await this.convertContent(this.privacyPolicy.fullContent);
      this.$nextTick(() => {
        this.handleScroll();
      });
    }
  }

  /**
   * Xử lý kiểm tra xem nội dung đã được cuộn tới cuối cùng hay chưa.
   */
  handleScroll() {
    this.$nextTick(() => {
      const content = this.$refs.privacyContent as HTMLElement;
      if (!content) return;
      
      // Không kiểm tra khi giao diện chưa hiển thị hoặc chiều cao bằng 0 (tránh tính toán sai khi modal đang fade-in)
      if (content.clientHeight === 0) return;
      
      // Kiểm tra xem nội dung có bị tràn (xuất hiện thanh cuộn dọc) hay không
      const hasOverflow = content.scrollHeight > content.clientHeight;
      if (hasOverflow) {
        // Nếu có thanh cuộn, xác định vị trí cuộn có sát đáy hay không (ngưỡng sai số 20px)
        const isBottom = content.scrollHeight - content.scrollTop <= content.clientHeight + 20;
        if (isBottom) {
          this.isScrolledToBottom = true;
          this.hasReachedBottom = true; // Lưu trạng thái đã chạm đáy thành công
          // Tự động xoá lỗi nếu lỗi hiện tại là yêu cầu đọc hết chính sách
          if (this.errorMessage === this.$t("policyRequireRead")) {
            this.errorMessage = "";
          }
        } else {
          // Reset lại trạng thái chưa cuộn xong nếu chưa từng chạm đáy trước đó
          // (Ngăn lỗi F5/render chậm gây kích hoạt nhầm trạng thái đồng ý khi mới hiển thị nội dung)
          if (!this.hasReachedBottom) {
            this.isScrolledToBottom = false;
          }
        }
      } else {
        // Nếu nội dung ngắn, nằm gọn trên 1 màn hình và không có thanh cuộn thì mặc định đã xem hết
        this.isScrolledToBottom = true;
        if (this.errorMessage === this.$t("policyRequireRead")) {
          this.errorMessage = "";
        }
      }
    });
  }

  /**
   * Bắt đầu tiến trình cuộn từ từ xuống dưới khi nhấn giữ chuột/chạm tay
   */
  startScrolling(event: Event) {
    if (event) {
      event.preventDefault(); // Tránh các hành vi mặc định như chọn text hoặc phóng to
    }
    const content = this.$refs.privacyContent as HTMLElement;
    if (!content) return;

    this.stopScrolling(); // Reset tiến trình cũ (nếu có) trước khi tạo tiến trình mới

    const scrollSpeed = 5; // Số pixel cuộn trên mỗi frame (tương đương ~300px/s ở 60fps)
    
    const performScroll = () => {
      // Dừng cuộn nếu đã cuộn tới sát cuối cùng
      if (content.scrollHeight - content.scrollTop <= content.clientHeight) {
        this.stopScrolling();
        return;
      }
      content.scrollTop += scrollSpeed;
      this.scrollIntervalId = requestAnimationFrame(performScroll);
    };

    this.scrollIntervalId = requestAnimationFrame(performScroll);
  }

  /**
   * Dừng tiến trình cuộn tự động khi thả chuột/rời ngón tay
   */
  stopScrolling() {
    if (this.scrollIntervalId) {
      cancelAnimationFrame(this.scrollIntervalId);
      this.scrollIntervalId = null;
    }
  }

  /**
   * Thay đổi trạng thái đồng ý khi click vào nhãn text
   */
  toggleAgreement() {
    this.isAgreed = !this.isAgreed;
    if (this.isAgreed) {
      this.errorMessage = ""; // Xoá thông báo lỗi khi đã chọn đồng ý
    }
  }

  /**
   * Xử lý xoá thông báo lỗi khi checkbox thay đổi trạng thái thành được chọn
   */
  onAgreedChange(val: boolean) {
    if (val) {
      this.errorMessage = "";
    }
  }

  async onClickAcceptPrivacy() {
    this.errorMessage = "";
    if (!this.isScrolledToBottom) {
      this.errorMessage = this.$t("policyRequireRead") as string;
      return;
    }
    if (!this.isAgreed) {
      this.errorMessage = this.$t("policyRequireAgree") as string;
      return;
    }
    try {
      this.showLoading();
      const clientAddress = await util.getClientAddress();
      const consentSource = PrivacyConsentSource.AGREE;
      await policyService.saveActivePolicyConsent({ clientAddress, consentSource });
      this.toastSuccessDelay(this.$t("withDrawCustomerSuccess") as string);
      this.$bvModal.hide(this.modalId);
    } catch (e) {
      this.toastError(e);
    } finally {
      this.hideLoading();
    }
  }

  async convertContent(content: string) {
    if (!content) return "";
    const isUrl = content.startsWith('http://') || content.startsWith('https://');
    if (isUrl) {
      try {
        const response = await fetch(content);
        if (!response.ok) throw new Error('Network response was not ok');
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc.body.innerHTML || html;
      } catch (error) {
        console.error("Error fetching privacy content:", error);
        return content;
      }
    }
    return content;
  }

  onClickLogout() {
    userService.signOut();
  }
}
</script>

